import { MakeEmbedWCCContentBlock } from 'components/content/mixins/embed';
import { DOMHelpers } from 'helpers/dom';
import { WCCContentBlock } from '../block/block';
import { WCCContentBlockConfig } from '../block/block.interfaces';

const ExtendedWCCContentBlock = [
    MakeEmbedWCCContentBlock(true)
].reduce((result, mixin) => mixin(result), WCCContentBlock);

export class WCCContentLineBreakBlock extends ExtendedWCCContentBlock {

    constructor(config: WCCContentBlockConfig) {
        super(config);
    }

    protected override getNodes() {
        return DOMHelpers.createBindedNodes('<br>', { });
    }
}